import { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { IoIosArrowBack } from "react-icons/io";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

export default function ShowHistory() {
    const navigate = useNavigate();
    const { state } = useLocation();
    const violation = state?.violation;
    const [history, setHistory] = useState([]);    

    useEffect(() => {
        if (!violation) return;

        const fetchHistory = async () => {
        const historyQuery = query(
            collection(db, "violations"),
            where("originalDocID", "==", violation.originalDocID), orderBy("modified_date", "asc")
        );

        const snapshot = await getDocs(historyQuery);

        setHistory(
            snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
            }))
        );
        };

        fetchHistory();
    }, [violation]);

    if (!violation) {
        return <p>No violation data found.</p>;
    }
    
    return (
        <div className="show-history">
            <div className="history-table" style={{ width: "100%", padding: "10px", boxSizing: "border-box" }}>
                <div className="history-back-button" onClick={() => navigate(-1)}>
                    <IoIosArrowBack style={{width: "100%", height: "40px", color: "#EFBF84"}}/>
                </div>

                <h3>Violation History: {violation.arsCode}</h3>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Version</TableCell>
                                <TableCell>Last Date Updated</TableCell>
                                <TableCell>Last Updated By</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {history.length > 0 ? (
                                    history.map((record, index) => (
                                    <Fragment key={record.id}>
                                        <TableRow>
                                            <TableCell style={{fontSize: "12px"}}>V{index + 1}</TableCell>
                                            {record.modified_date === null ?
                                                <TableCell style={{fontSize: "12px"}}>Violation Created on {record.add_date.toDate().toLocaleString()}</TableCell> 
                                                : <TableCell style={{fontSize: "12px"}}>{record.modified_date.toDate().toLocaleString()}</TableCell>}

                                            {record.modified_user === null ?
                                                <TableCell style={{fontSize: "12px"}}>Added By: {record.add_user}</TableCell> 
                                                : <TableCell style={{fontSize: "12px"}}>{record.modified_user}</TableCell>}
                                        </TableRow>
                                    </Fragment>
                                ))
                            ) : (
                                <TableRow>  
                                    <TableCell colSpan={6} align="center">
                                        No history records found.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}
